import { useMemo } from 'react';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { filterLocationIdsByACLs } from '@frontend/auth-helpers';
import { useAppScopeStore } from '@frontend/scope';

type UseInboxLocationIdsProps = {
  locationIds?: string[];
};

export const useInboxLocationIds = ({ locationIds: providedLocationIds }: UseInboxLocationIdsProps = {}): string[] => {
  const { selectedLocationIds } = useAppScopeStore();
  const locationIds = useMemo(
    () =>
      filterLocationIdsByACLs({
        locationIds: providedLocationIds?.length ? providedLocationIds : selectedLocationIds,
        acls: Permission.SMS_INBOX_MANAGE,
      }),
    [selectedLocationIds, providedLocationIds]
  );

  return locationIds;
};
